import { UserDocumentFiles } from "../../dtos/user.dto";
import { UserFormData } from "./users.types";
import { User } from "../../interfaces/user.interface";

export const USER_CURRENCIES = ["USD", "EUR", "GBP", "HKD", "AUD", "CNY"] as const;

/**
 * Documents each account type uploads, as [file field, i18n label key].
 * A personal user proves identity only; a broker files trade paperwork; a company
 * files its registration and branding. Showing the full set to everyone invited
 * uploads that do not belong to the account being created.
 */
export const ACCOUNT_TYPE_DOCUMENTS: Record<
  UserFormData["accountType"],
  ReadonlyArray<readonly [keyof UserDocumentFiles, string]>
> = {
  personal: [["idFile", "idDocument"]],
  broker: [
    ["licenseFile", "licenseDocument"],
    ["credentialsFile", "credentialsDocument"],
  ],
  company: [
    ["companyLogo", "companyLogo"],
    ["brFile", "brDocument"],
  ],
};

/** Shown for every account type — a profile picture, not account paperwork. */
export const AVATAR_DOCUMENT: readonly [keyof UserDocumentFiles, string] = ["avatar", "avatar"];

/** Badge colours for User.verificationStatus in the users table. */
export const VERIFICATION_STATUS_BADGE: Record<NonNullable<User["verificationStatus"]>, string> = {
  unverified: "bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200",
  pending_review: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
  verified: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  action_required: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
};
